import React, { useState } from "react";
import { SCREEN_TOTAL, GET_SCREEN_INDEX } from "../../../componets/commonUtils";
import { ScrollService } from "../../../componets/ScrollService";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Header.css";

export function Header() {
  const [selectedScreen, setSelectedScreen] = useState(0);
  const [showHeaderOptions, setShowHeaderOptions] = useState(false);

  const updateCurrentScreen = (currentScreen) => {
    if (!currentScreen || !currentScreen.screenInView) return;
    let screenIndex = GET_SCREEN_INDEX(currentScreen.screenInView);
    if (screenIndex < 0) return;
  };
  let currentScreenSubscription =
    ScrollService.currentScreenBroadcaster.subscribe(updateCurrentScreen);

  const getHeaderOptions = () => {
    return SCREEN_TOTAL.map((Screen, i) => (
      <div
        key={Screen.screen_name}
        className={getHeaderOptionsClass(i)}
        onClick={() => switchScreen(i, Screen)}
      >
        <span>{Screen.screen_name}</span>
      </div>
    ));
  };

  const getHeaderOptionsClass = (index) => {
    let classes = "header-option ";
    if (index < SCREEN_TOTAL.length - 1) classes += "header-option-separator ";

    if (selectedScreen === index) classes += "selected-header-option ";

    return classes;
  };

  const switchScreen = (index, screen) => {
    let screenComponent = document.getElementById(screen.screen_name);
    if (!screenComponent) return;

    screenComponent.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
    setSelectedScreen(index);
    setShowHeaderOptions(false);
  };

  return (
    <div>
      <div
        className={"header-container"}
        onClick={() => setShowHeaderOptions(!showHeaderOptions)}
      >
        <div className={"header-parent"}>
          <div
            className={"header-hamburger"}
            onClick={() => setShowHeaderOptions(!showHeaderOptions)}
          >
            <FontAwesomeIcon
              className={"header-hamburger-bars"}
              icon={faBars}
            />
          </div>
          <div className={"header-logo"}>
            <span>Andreas Baade</span>
          </div>
          <div
            className={
              showHeaderOptions
                ? "header-options show-hamburger-options "
                : "header-options"
            }
          >
            {getHeaderOptions()}
          </div>
        </div>
      </div>
    </div>
  );
}
